import React from "react";
import useReveal from "./useReveal";

/**
 * Wraps a section/element so it fades + slides in the first time it enters
 * the viewport. Purely presentational - see `landing.scss` for the actual
 * transition and the `prefers-reduced-motion` opt-out.
 */
export default function Reveal({ as: Tag = "div", delay = 0, className = "", style, children, ...rest }) {
  const [ref, visible] = useReveal();

  return (
    <Tag
      ref={ref}
      className={`landing-reveal ${visible ? "reveal-visible" : ""} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : "0ms", ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
